import u from "./ghl-ui.es1589.js";
import l from "./ghl-ui.es1590.js";
import n from "./ghl-ui.es1586.js";
import c from "./ghl-ui.es1587.js";
import h from "./ghl-ui.es1588.js";
import m from "./ghl-ui.es1591.js";
import { Parser as v } from "./ghl-ui.es1670.js";
import { parseNDigitsSigned as f } from "./ghl-ui.es1671.js";
import C from "./ghl-ui.es1661.js";
var P = /* @__PURE__ */ function(p) {
  c(i, p);
  var s = h(i);
  function i() {
    var r;
    u(this, i);
    for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
      t[a] = arguments[a];
    return r = s.call.apply(s, [this].concat(t)), m(n(r), "priority", 130), m(n(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return l(i, [{
    key: "parse",
    value: function(e, t) {
      return t === "R" ? f(4, e) : f(t.length, e);
    }
  }, {
    key: "set",
    value: function(e, t, a) {
      var o = /* @__PURE__ */ new Date(0);
      return o.setUTCFullYear(a, 0, 4), o.setUTCHours(0, 0, 0, 0), C(o);
    }
  }]), i;
}(v);
export {
  P as ISOWeekYearParser
};
